import styled from "styled-components";
import { SM } from "../../constants/mediaQueries";

export const StarContainer = styled.img`
  height: ${props => props.size || 50}px;
  position: absolute;
  z-index: 950;
  top: ${props => props.top}vh;
  left: ${props => props.left}vw;
  will-change: transform;

  @media (max-width: ${SM}) {
    height: ${props => props.size/2 || 20}px;
    left: ${props => props.left}vw;
  }
`;